import { render, staticRenderFns } from "./TodoBox.vue?vue&type=template&id=1214acfc&"
import script from "./TodoBox.vue?vue&type=script&lang=js&"
export * from "./TodoBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports